import Component from '@glimmer/component';

interface BetaLimitWarningSignature {
  // Args: {};
  Blocks: {
    default: [];
  };
}

/**
 *
 * `BetaLimitWarning` yields content if the launchDarkly flag
 * 'hcp-quota-consul-clusters' is equal to 0. The yield is wrapped with
 * alert banner content.
 *
 *
 * ```
 * <BetaLimitWarning>
 *   Some Content
 * </BetaLimitWarning>
 * ```
 *
 * @class BetaLimitWarning
 *
 */

export default class BetaLimitWarningComponent extends Component<BetaLimitWarningSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BetaLimitWarning: typeof BetaLimitWarningComponent;
    'beta-limit-warning': typeof BetaLimitWarningComponent;
  }
}
